__turbopack_context__.v({
  "body": "vhEo_W_body",
  "buttonOverlay": "vhEo_W_buttonOverlay",
  "container": "vhEo_W_container",
  "dialogTitle": "vhEo_W_dialogTitle",
  "footer": "vhEo_W_footer",
  "header": "vhEo_W_header",
  "imageVideoWrapper": "vhEo_W_imageVideoWrapper",
  "leftButton": "vhEo_W_leftButton",
  "navButton": "vhEo_W_navButton",
  "playIconButton": "vhEo_W_playIconButton",
  "rightButton": "vhEo_W_rightButton",
  "slide": "vhEo_W_slide",
  "slideZoomed": "vhEo_W_slideZoomed",
  "slider": "vhEo_W_slider",
  "sliderContainer": "vhEo_W_sliderContainer",
  "videoHidden": "vhEo_W_videoHidden",
  "videoVisible": "vhEo_W_videoVisible",
  "wrapper": "vhEo_W_wrapper",
  "zoomButton": "vhEo_W_zoomButton",
  "zoomContainer": "vhEo_W_zoomContainer",
  "zoomImageWrapper": "vhEo_W_zoomImageWrapper",
});
